<template>
  <div class="container">
    <!-- 菜单导航 -->
    <Menu></Menu>
    <!-- 正式课内页 -->
    <div class="curriculumDetail">
      <div class="breadcrumb_box">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/curriculum' }">正式课</a></el-breadcrumb-item>
          <el-breadcrumb-item>{{ des.title }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="course-body">
        <div class="left">
          <img :src="des.thumb" class="course-banner" />
        </div>
        <div class="right">
          <div class="course-info_wrap">
            <div class="wrap__top">
              <h3>{{ des.title }}</h3>
              <div class="course-data">
                有 <b>{{ des.study_num }}</b>
                位同学正在学习
              </div>
              <div class="course-desc">
                {{ des.introduction }}
              </div>
            </div>
            <div class="wrap__bottom">
              <div class="detail-price">
                <span class="price-tag">￥</span>
                <span>{{ des.discount_price }}</span>
              </div>
              <div class="course-handle">
                <span onclick="__egeelTalk()">立即报名</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="course-details-wrap_width">
        <div class="course-left_area">
          <div class="the-tabs">
            <ul class="heads">
              <li class="active">课程详情 </li>
            </ul>
          </div>
          <div class="description">
            <div class="course_content_box">
              <p v-html="des.content"></p>
            </div>
          </div>
        </div>
        <div class="course-right_area">
          <div class="label">
            <div class="label-line"></div>
            <div class="label-tit">猜你想学</div>
          </div>
          <div class="course-recommendation_wrap">
            <div class="course-list" v-for="(item, i) in tuijData" :key="i" @click="toDetails(item.id)">
              <div class="img-box">
                <img :src="item.thumb" />
              </div>
              <div class="list_right">
                <div class="right__top">
                  <div class="title">{{ item.name }}</div>
                  <p class="price">
                    <span>￥</span>
                    {{ item.discount_price }}
                  </p>
                </div>
                <div class="study_num">
                  <span>{{ item.study_num == null ? "0" : item.study_num }}</span>
                  位同学在学
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部链接 -->
    <Footer></Footer>
  </div>
</template>
<script>
  import Menu from '@/components/view/Menu'
  import Footer from '@/components/view/Footer'
  export default {
    name: 'home',
    components: {
      Menu,
      Footer
    },
    data() {
      return {
        activeName: 'first',
        msg: 'Welcome to Your Vue.js App123',
        des: {
          title: "",
          chapter: []
        },
        tuijData: []
      }
    },
    created() {
      this.getInfo()
    },
    methods: {
      getInfo() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/course/detail', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: {
            id: this.$route.query.id
          }
        }).then(res => {
          this.des = res.data.data

        }).catch(err => {
          console.log(err)
        })
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/course/RecommendCourse', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token')
          },
          data: {
            limit: 10
          }
        }).then(res => {
          let data = res.data.data.data
          this.tuijData = data
        }).catch(err => {
          console.log(err)
        })
      },
      toDetails(id) {
        this.$router.push({
          path: "/curriculumDetail",
          query: {
            id: id
          }
        })
        this.getInfo()
      },
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /deep/ .course_content_box img {
    width:100%;
  }
  .container {
    background-color: #f7f7f7;
  }

  .curriculumDetail {
    padding: 0px;
    margin: 0px;
    width: 1200px;
    margin: 0 auto;
  }

  .course-details-wrap_width {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0 0 30px 0;
  }

  .course-right_area {
    margin-left: 15px;
    box-sizing: border-box;
    width: 335px;
    background-color: #fff;
    border-radius: 8px;
    padding: 0 16px;
  }

  .course-left_area {
    width: 850px;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 8px;
    padding: 24px
  }

  .course-recommendation_wrap {
    padding: 0;
    margin: 0;
  }

  .course-list {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    cursor: pointer;
  }

  .list_right {
    flex: 1;
    display: flex;
    flex-direction: column;
    text-align: left;
    justify-content: space-between;
  }

  .study_num {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #a3a8ab;
  }

  .right__top {
    margin: 0;
  }

  .right__top .title {
    width: 144px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-bottom: 10px;
    color: #18252c;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
  }

  .right__top .price {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ff2b26;
    line-height: 20px;
  }

  .img-box {
    width: 140px;
    height: 78px;
    margin-right: 10px;
    overflow: hidden;
  }

  .img-box img {
    width: 100%;
    height: 100%;
    border-radius: 7px;
    -o-object-fit: cover;
    object-fit: cover;
  }

  .label {
    position: relative;
    display: flex;
    align-items: center;
    padding: 20px 0;
  }

  .label-tit {
    position: relative;
    text-align: left;
    padding-left: 16px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #18252c;
  }

  .label-line {
    width: 6px;
    height: 18px;
    background-color: #FABE00;
  }

  .the-tabs {
    border: 0;
  }

  .description {
    margin-top: 25px;
  }

  .description img {
    display: block;
  }

  .heads {
    display: flex;
  }

  .course-details-wrap_width .course-left_area .the-tabs .heads li {
    min-width: 72px;
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC, Helvetica, STHeiti, Microsoft YaHei, "sans-serif";
    font-weight: 600;
    color: #747c80;
    line-height: 25px;
    cursor: pointer;
    z-index: 10;
    text-align: center;
  }

  .active {
    font-weight: 600;
    color: #18252c !important;
    border-bottom: 4px solid #00d753;
  }

  .content_top {
    padding: 40px 0 30px 0;
  }

  .course-body {
    display: flex;
    justify-content: space-between;
    background-color: white;
    padding: 24px;
    border-radius: 8px;
    margin-bottom: 20px;
  }

  .course-body .left {
    width: 530px;
    height: 295px;
    margin-right: 20px;
    overflow: hidden;
    border-radius: 8px;
  }

  .course-body .left .course-banner {
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
  }

  .course-body .right {
    flex: 1;
    box-sizing: border-box;
    position: relative;
  }

  .course-body .right .course-info_wrap {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .course-body .right .wrap__bottom {
    display: flex;
    justify-content: space-between;
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ff2b26;
  }

  .wrap__bottom .price-tag {
    font-size: 18px;
  }

  .wrap__bottom .course-handle {
    width: 295px;
    height: 56px;
    font-size: 19px;
    line-height: 56px;
    text-align: center;
    background: linear-gradient(270deg, #ff4d40, #ff7e75);
    border-radius: 8px;
    cursor: pointer;
  }

  .wrap__bottom .course-handle span {
    font-size: 19px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #fff;
    line-height: 26px;
  }

  .course-body .right .course-info_wrap .wrap__top h3 {
    height: 45px;
    font-size: 32px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #18252c;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 600px;
    text-align: left;
  }

  .course-body .right .course-desc {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #747c80;
    line-height: 25px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 6;
    text-align: left;
  }

  .course-body .right .course-data {
    text-align: left;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #272822;
    margin: 10px 0 20px 5px;
  }

  .course-body .right .course-data b {
    font-size: 20px;
    font-weight: normal;
    color: #FABE00
  }
</style>



// WEBPACK FOOTER //
// src/components/view/Curriculums/curriculumDetail.vue